/* eslint-disable */
const configAmazon = {
  topolKey: process.env.REACT_APP_AMAZON_TOPOLKEY,
  region: process.env.REACT_APP_AMAZON_REGION,
  linkedInAppId: process.env.REACT_APP_AMAZON_LINKEDIN_APP_ID,
  api: process.env.REACT_APP_AMAZON_API,
  userPoolId: process.env.REACT_APP_AMAZON_USER_POLL_ID,
  appClientId: process.env.REACT_APP_AMAZON_APP_CLIENT_ID,
  publicBucketUrl: process.env.REACT_APP_AMAZON_PUBLIC_BUCKET_URL,
};

export default {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  ...configAmazon,
};
